import React from 'react';
import { Image, StyleSheet } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useCompanyLogo } from '../hooks/useCompanyLogo';

export const HeaderLogo = ({ size = 30, style }) => {
  const { logo, loading } = useCompanyLogo();

  if (loading) {
    // Optionally show a placeholder or nothing
    return null;
  }

  if (logo) {
    return (
      <Image
        source={{ uri: logo }}
        style={[styles.logo, { width: size, height: size, borderRadius: size / 2 }, style]}
        resizeMode="cover"
      />
    );
  }

  // Fallback icon
  return (
    <MaterialCommunityIcons
      name="office-building"
      size={size}
      color="#fff"
      style={style}
    />
  );
};

const styles = StyleSheet.create({
  logo: {
    resizeMode: 'cover',
  },
});